/* ============================================================
   ET Fit Quiz — PDP-028 "Will It Fit Me?"
   3 questions (size / height / figure) -> recommended fit.
   Sizes map across systems by index (EU 32 = US 2 = UK 4).
   ============================================================ */
(function () {
  'use strict';

  /* Default mapping: per size (1-8), one string per height (1-4),
     chars = figure 1-3. X=relaxed L=loose R=regular S=shaped C=close.
     Can be overridden per-cell via the block's "Mapping override" setting. */
  var FIT_CHARS = { X: 'relaxed', L: 'loose', R: 'regular', S: 'shaped', C: 'close' };
  var MAP_ROWS = {
    1: ['XLR', 'XLS', 'RSC', 'RSC'],
    2: ['XLS', 'LRS', 'RRS', 'RSC'],
    3: ['XLS', 'LRS', 'RSC', 'RSC'],
    4: ['XLS', 'LRS', 'RSC', 'RSC'],
    5: ['XRS', 'LRS', 'RSC', 'RSC'],
    6: ['XLS', 'LRS', 'RSC', 'RSC'],
    7: ['LRS', 'RSC', 'RSC', 'RSC'],
    8: ['RSC', 'RSC', 'RSC', 'RSC']
  };

  var THUMB_POS = { relaxed: '2%', loose: '26%', regular: '50%', shaped: '74%', close: '98%' };

  function buildMap(root) {
    var map = {};
    Object.keys(MAP_ROWS).forEach(function (size) {
      MAP_ROWS[size].forEach(function (row, h) {
        row.split('').forEach(function (ch, f) {
          map[size + '-' + (h + 1) + '-' + (f + 1)] = FIT_CHARS[ch];
        });
      });
    });
    var override = root.querySelector('[data-fq-mapping]');
    if (override) {
      override.textContent.split(/\n+/).forEach(function (line) {
        var m = line.trim().match(/^(\d+-\d+-\d+)\s*[:=]\s*(loose|relaxed|regular|shaped|close)/i);
        if (m) map[m[1]] = m[2].toLowerCase();
      });
    }
    return map;
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('et:fit-quiz:' + name, { detail: detail || {} }));
  }

  function initQuiz(root) {
    if (root.dataset.fqInit) return;
    root.dataset.fqInit = '1';

    /* Move the modal to <body>: ancestors inside the product section create
       stacking contexts, so the sticky header would overlay it otherwise. */
    var orphan = document.querySelector('body > [data-et-fit-quiz][data-fq-portaled]');
    if (orphan && orphan !== root) orphan.remove();
    root.dataset.fqPortaled = '1';
    document.body.appendChild(root);

    var map = buildMap(root);
    var answers = { 1: null, 2: null, 3: null };
    var lastFit = null;
    var system = root.dataset.defaultSystem || 'eu';
    var steps = root.querySelectorAll('[data-fq-step]');
    var dropdown = root.querySelector('[data-fq-dropdown]');

    function showStep(name) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.fqStep === String(name));
      });
    }

    function currentStep() {
      var active = root.querySelector('[data-fq-step].is-active');
      return active ? active.dataset.fqStep : '1';
    }

    function syncSystem() {
      root.querySelectorAll('[data-fq-sizes]').forEach(function (grid) {
        grid.hidden = grid.dataset.fqSizes !== system;
      });
      var selectedOption = root.querySelector('[data-fq-system="' + system + '"]');
      var toggleFlag = root.querySelector('[data-fq-flag]');
      var toggleLabel = root.querySelector('[data-fq-system-label]');
      if (selectedOption) {
        var optFlag = selectedOption.querySelector('[data-fq-option-flag]');
        var optLabel = selectedOption.querySelector('[data-fq-option-label]');
        if (toggleFlag && optFlag) toggleFlag.innerHTML = optFlag.innerHTML;
        if (toggleLabel && optLabel) toggleLabel.textContent = optLabel.textContent;
      }
      root.querySelectorAll('[data-fq-system]').forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.dataset.fqSystem === system);
      });
      syncSelections();
    }

    function syncSelections() {
      root.querySelectorAll('[data-fq-answer]').forEach(function (btn) {
        var step = btn.dataset.fqAnswer;
        btn.classList.toggle('is-selected', answers[step] === btn.dataset.fqValue);
      });
      root.querySelectorAll('[data-fq-next]').forEach(function (btn) {
        var pane = btn.closest('[data-fq-step]');
        if (pane) btn.classList.toggle('is-disabled', !answers[pane.dataset.fqStep]);
      });
    }

    function showResult() {
      var key = answers[1] + '-' + answers[2] + '-' + answers[3];
      var fit = map[key] || 'regular';
      var data = root.querySelector('[data-fq-fit="' + fit + '"]');
      var nameEl = root.querySelector('[data-fq-fit-name]');
      var descEl = root.querySelector('[data-fq-fit-desc]');
      var thumb = root.querySelector('[data-fq-thumb]');
      if (data) {
        var name = data.querySelector('[data-fq-name]');
        var desc = data.querySelector('[data-fq-desc]');
        if (nameEl && name) nameEl.textContent = name.textContent;
        if (descEl && desc) descEl.innerHTML = desc.innerHTML;
      }
      if (thumb) thumb.style.setProperty('--fq-pos', THUMB_POS[fit] || '50%');
      lastFit = fit;
      showStep('result');
      emit('result', { fit: fit, key: key });
    }

    function open() {
      if (answers[1] && answers[2] && answers[3]) {
        showResult();
      } else {
        showStep(1);
      }
      syncSystem();
      root.classList.add('active');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      emit('open', {});
    }

    function close() {
      root.classList.remove('active');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      emit('close', { step: currentStep() });
    }

    root.addEventListener('click', function (e) {
      var t;

      if (e.target.closest('[data-fq-close]')) {
        close();
        return;
      }

      t = e.target.closest('[data-fq-dropdown-toggle]');
      if (t && dropdown) {
        dropdown.classList.toggle('is-open');
        return;
      }

      t = e.target.closest('[data-fq-system]');
      if (t) {
        system = t.dataset.fqSystem;
        if (dropdown) dropdown.classList.remove('is-open');
        syncSystem();
        return;
      }

      t = e.target.closest('[data-fq-answer]');
      if (t) {
        answers[t.dataset.fqAnswer] = t.dataset.fqValue;
        syncSelections();
        emit('answer', { step: t.dataset.fqAnswer, value: t.dataset.fqValue });
        return;
      }

      t = e.target.closest('[data-fq-next]');
      if (t) {
        var pane = t.closest('[data-fq-step]');
        var step = pane ? parseInt(pane.dataset.fqStep, 10) : 1;
        if (!answers[step]) return;
        if (step >= 3) showResult();
        else showStep(step + 1);
        return;
      }

      t = e.target.closest('[data-fq-prev]');
      if (t) {
        var prevPane = t.closest('[data-fq-step]');
        var prevStep = prevPane ? parseInt(prevPane.dataset.fqStep, 10) : 2;
        showStep(Math.max(1, prevStep - 1));
        return;
      }

      if (e.target.closest('[data-fq-restart]')) {
        answers = { 1: null, 2: null, 3: null };
        lastFit = null;
        syncSelections();
        showStep(1);
        emit('restart', {});
        return;
      }

      t = e.target.closest('[data-fq-atc]');
      if (t) {
        var section = root.closest('.shopify-section');
        var atcBtn =
          (section && section.querySelector('[data-product-form] [data-add-to-cart]')) ||
          document.querySelector('[data-product-form] [data-add-to-cart]');
        if (atcBtn && !atcBtn.disabled) atcBtn.click();
        emit('atc', { fit: lastFit });
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('active')) close();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fq-open]')) {
        e.preventDefault();
        open();
      }
    });

    syncSystem();
  }

  /* When Intelligems reveals the trigger, flag the body so companion
     styles (e.g. one-size bar left alignment on mobile) can apply. */
  function detectVariant() {
    var wrap = document.querySelector('.et-fit-quiz__trigger-wrap');
    if (wrap && getComputedStyle(wrap).display !== 'none') {
      document.body.classList.add('et-fq-on');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-et-fit-quiz]').forEach(initQuiz);
    detectVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('ig:ready', detectVariant);
  document.addEventListener('shopify:section:load', initAll);
})();
